import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { CustomerForm } from '@/components/forms/customer-form'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/customers/new')({
    component: NewCustomerPage,
})

function NewCustomerPage() {
    const navigate = useNavigate()

    return (
        <div className="max-w-2xl space-y-4">
            <h1 className="text-xl font-semibold">{m.customer_add_new()}</h1>
            <div className="rounded-md border p-6">
                <CustomerForm
                    onSuccess={() => void navigate({ to: '/customers' })}
                    onCancel={() => void navigate({ to: '/customers' })}
                />
            </div>
        </div>
    )
}
